import React, { useState } from 'react'
import { analytics } from 'Modules/Analytics'
import { initiatives } from 'Modules/Analytics/trackActionInterface/Impact/Initiatives'
import { useAppState } from 'Context/AppContext/AppContext'
import { Box } from '@mui/material'
import { Moment } from 'moment'
import moment from 'moment/moment'
import { ChartDataPoint, Goal } from 'Generated/graphql-types'
import {
  Content,
  DateRangeFilters,
  ChartDataTableContainer,
} from './ChartDataTable.styled'
import { EditChartDataTable } from '../EditChartDataTable/EditChartDataTable'
import { DatePicker } from '../../../../SharedComponents/DatePicker/DatePicker'

type EditDataModalProps = {
  goal: Goal
  isAddingData: boolean
  isGoalSharedWithFunder: boolean
  newEntryDate: Moment | null
  onAddData: () => void
  onEmptyStateAddData: () => void
  onEditData?: (row: {
    date: string
    values: (Omit<ChartDataPoint, 'id'> & { id: number | null })[]
  }) => void
  onChangeNewEntryDate: (date: Moment | null) => void
  simple?: boolean
  hideFilters?: boolean
}

export const ChartDataTable = ({
  goal,
  isAddingData,
  newEntryDate,
  onAddData,
  onChangeNewEntryDate,
  isGoalSharedWithFunder,
  onEditData,
  onEmptyStateAddData,
  simple,
  hideFilters,
}: EditDataModalProps) => {
  const {
    nonprofitOrgConfig: { role, nonprofitOrgRole },
  } = useAppState()
  const [filterEndDate, setFilterEndDate] = useState<Moment | null>(null)
  const [filterStartDate, setFilterStartDate] = useState<Moment | null>(null)

  const handleFilterDates = (date: Moment | null, type: 'start' | 'end') => {
    analytics.trackActionCreator(initiatives.Goal_Chart_Filter_Clicked)({
      role,
      relationship: nonprofitOrgRole,
    })
    if (type === 'start') setFilterStartDate(date ? moment(date) : null)
    if (type === 'end') setFilterEndDate(date ? moment(date) : null)
  }

  const datePickerStyles = { maxWidth: '200px' }

  return (
    <ChartDataTableContainer>
      <Content>
        {!hideFilters && (
          <Box display='flex' justifyContent='space-between'>
            <DateRangeFilters>
              <DatePicker
                date={filterStartDate}
                label='Start date (Optional)'
                onDateSelected={(startDate) =>
                  handleFilterDates(startDate, 'start')
                }
                styles={datePickerStyles}
              />
              <DatePicker
                date={filterEndDate}
                label='End date (Optional)'
                onDateSelected={(endDate) => handleFilterDates(endDate, 'end')}
                styles={datePickerStyles}
              />
            </DateRangeFilters>
          </Box>
        )}
        <EditChartDataTable
          onEmptyStateAddData={onEmptyStateAddData}
          goalId={goal.id.toString()}
          filterEndDate={filterEndDate}
          filterStartDate={filterStartDate}
          isAddingData={isAddingData}
          onEditData={onEditData}
          newEntryDate={newEntryDate}
          onAddData={onAddData}
          onChangeNewEntryDate={onChangeNewEntryDate}
          isGoalSharedWithFunder={isGoalSharedWithFunder}
        />
      </Content>
    </ChartDataTableContainer>
  )
}
